module.exports = __webpack_public_path__ + "img/do.c33b8d86.svg";